if (!customElements.get('address-autocomplete')) {
  customElements.define('address-autocomplete',
    class AddressAutocomplete extends HTMLElement {
      
      connectedCallback() {
        const input = this.querySelector('input');
        if (input) new AutoCompletion({ inputField: input });
      }

    }
  );
}
